import { Link, useParams, useSearchParams } from 'react-router-dom';
import { EmptyState, PageHeader } from '@aigovops/design-system';
import { useOptionalWorkspace } from '../lib/workspace';
import { useRequiredProfile } from '../lib/auth';

export function AuditEventDetail() {
  useRequiredProfile();
  const { eventId } = useParams<{ eventId: string }>();
  const workspaceCtx = useOptionalWorkspace();
  const prefix = workspaceCtx ? `/w/${workspaceCtx.workspace.slug}/app` : '/app'; // scope-check-ignore: legacy fallback
  const [searchParams] = useSearchParams();
  const returnItem = searchParams.get('item');
  const returnRange = searchParams.get('range');
  const backHref = `${prefix}/audit${returnItem ? `?item=${returnItem}` : ''}${returnRange ? `${returnItem ? '&' : '?'}range=${returnRange}` : ''}`;

  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <Link
        to={backHref}
        style={{ fontSize: 'var(--font-size-3xs)', color: 'var(--accent)', textDecoration: 'none' }}
      >
        ← Back to audit log
      </Link>
      <PageHeader
        title="Audit event"
        subtitle={eventId ?? 'Unknown event'}
      />
      <EmptyState
        title="Event detail loading"
        description="The full event detail view is being built. Check the audit log for a summary of this event."
      />
    </div>
  );
}
